import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOneIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 24,
	viewBox: "0 0 26 24",
	fill: "parent",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12.714,
			cy: 12,
			rx: 12.714,
			ry: 12,
			fill: "#F7F8F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.643 17H11.5307V11.2168L11.5512 10.2666L11.5854 9.22754C11.2345 9.57845 10.9906 9.80859 10.8539 9.91797L9.70548 10.8408L8.68692 9.56934L11.9067 7.00586H13.643V17Z",
			fill: "parent"
		})
	]
});
const ForwardRef = forwardRef(SvgOneIcon);
export { ForwardRef as ReactComponent };
